import { useState, useEffect } from 'react';
import React from "react";
import { Table, Modal, Button, Form, Tab, Tabs, Row, Container, Col, Card, Spinner } from 'react-bootstrap';
// import { FaEdit } from 'react-icons/fa';
import { TiDelete } from "react-icons/ti";
import axios from 'axios';
import { trackPromise } from 'react-promise-tracker';
import Alert from 'react-bootstrap/Alert';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash, faAdd } from '@fortawesome/free-solid-svg-icons'; 
import "./eventos.css";

function TableEventos({ id }) {

    const [show, setShow]                                                   = useState(false);
    const [showDelete, setShowDelete]                                       = useState(false);
    const [showAdd, setShowAdd]                                             = useState(false);
    const [deleteId, setDeleteId]                                           = useState(false);
    const [items, setItems]                                                 = useState([]);
    const [showAlert, setShowAlert]                                         = useState(false);
    const [showAlertDelete, setShowAlertDelete]                             = useState(false);
    const [horarios, setHorarios]                                           = useState([]);
    const [statusBtnAdd, setStatusBtnAdd]                                   = useState(false);
    const [btnSubmitEdit, setBtnSubmitEdit]                                 = useState(false);
    const [showLoader, setShowLoader]                                       = useState(false);

    // ---------- nuevo eventos ------------
    const [selectVenues, setSelectVenues]                                   = useState([]);
    const [inputNombre, setInputNombre]                                     = useState("");
    const [inputVenue, setInputVenue]                                       = useState("");
    const [inputFecha, setInputFecha]                                       = useState("");
    const [inputHorario, setInputHorario]                                   = useState("");
    const [inputHorarioFin2, setInputHorarioFin2]                           = useState("");
    const [inputStatus, setInputStatus]                                     = useState("");
    const [inputRestriccion, setInputRestriccion]                           = useState("");
    const [inputHorariosEspecificos, setInputHorariosEspecificos]           = useState(1);
    const [inputCapacidad, setInputCapacidad]                               = useState("");
    const [image, setImage]                                                 = useState({ preview: '', data: '' })

    // ----- edit eventos -----------
    const [inputIdEdit, setInputIdEdit]                                     = useState("");
    const [inputNombreEdit, setInputNombreEdit]                             = useState("");
    const [inputVenueEdit, setInputVenueEdit]                               = useState("");
    const [inputFechaEdit, setInputFechaEdit]                               = useState("");
    const [inputHorarioEdit, setInputHorarioEdit]                           = useState("");
    const [inputHorarioFinEdit, setInputHorarioFinEdit]                     = useState("");
    const [inputStatusEdit, setInputStatusEdit]                             = useState("");
    const [inputRestriccionEdit, setInputRestriccionEdit]                   = useState("");
    const [inputHorariosEspecificosEdit, setInputHorariosEspecificosEdit]   = useState("");
    const [inputCapacidadEdit, setInputCapacidadEdit]                       = useState("");
    const [htmlCode, setHtmlCode]                                           = useState("");
    const [imageEdit, setImageEdit]                                         = useState({ preview: '', data: '' })

    // --------------------------- add horarios ----------------------------

    const [inputHorarioInicio, setInputHorarioInicio]                       = useState("");
    const [inputHorarioFin, setInputHorarioFin]                             = useState(0);
    const [inputCapacidadHorario, setInputCapacidadHorario]                 = useState("");
    const [showDeleteHorario, setShowDeleteHorario]                         = useState(false);
    const [deleteIdHorario, setDeleteIdHorario]                             = useState(false);


    const handleClose               = () => setShow(false);
    const handleCloseDelete         = () => setShowDelete(false);
    const handleCloseDeleteHorario   = () => setShowDeleteHorario(false);
    const handleCloseAdd            = () => setShowAdd(false);

    const handleFileChange = (e) => {
        
        // if (e.target.files && e.target.files[0]) {
        //     console.log(e.target.files[0])
        //     if (e.target.files[0].size > 1 * 1000 * 1024) {
        //         console.log("File with maximum size of 1MB is allowed");
        //         return false;
        //     }

        //     // do other operation
        // }

        if (e.target.files[0]) {

                const img           = document.createElement('img');
                const selectedImage = e.target.files[0];
                const objectURL     = URL.createObjectURL(selectedImage);
                img.onload          = function handleLoad() {
                        
                    console.log(`Width: ${img.width}, Height: ${img.height}`);
            
                    if (img.width === 640 && img.height === 320) {
                        const img2 = {
                            preview: URL.createObjectURL(e.target.files[0]),
                            data: e.target.files[0],
                        }
                        setImage(img2)
                    }
                    else{
                        alert("Error, La imagen debe de medir 640px x 320px.")
                        e.target.value = null;
                    }
                
                    URL.revokeObjectURL(objectURL);
                };
            
                img.src = objectURL;
                //document.body.appendChild(img);                
        }
        
    }

    const handleFileChangeEdit = (e) => {
        
        const img = {
          preview: URL.createObjectURL(e.target.files[0]),
          data: e.target.files[0],
        }
        setImageEdit(img)
    }

    const handleShow = (item_id) => {
        
        setShow(true);
        setInputNombreEdit("")
        setInputFechaEdit("")
        setInputHorarioEdit("")
        setInputHorarioFinEdit("")
        setInputVenueEdit("")
        setInputStatusEdit("")
        setInputRestriccionEdit("")
        setInputHorariosEspecificosEdit("")
        setInputCapacidadEdit("")
    
        let ud          = sessionStorage.getItem('userData');
        let userData    = JSON.parse(ud);

        const instance = axios.create({
            baseURL: '',
            timeout: 5000,
            headers: {'content-type': 'application/json', 'Authorization': 'Bearer '+userData.access_token}
            });
        
            instance.get('../api/get-evento/'+item_id)
            .then(response => {

                // var today       = new Date(response.data.data[0].fecha_evento_format);
                // var year        = today.getFullYear();
                // var mes         = today.getMonth()+1;
                // mes             = mes.toString().padStart(2, '0')
                // var dia         = today.getDate();
                // dia             = dia.toString().padStart(2, '0')
                // // var fecha_ok    = year+"-"+mes+"-"+dia;

                setInputIdEdit(response.data.data[0].id)
                setInputNombreEdit(response.data.data[0].nombre)
                setInputFechaEdit(response.data.data[0].fecha_evento_format)
                setInputHorarioEdit(response.data.data[0].horario_format)
                setInputHorarioFinEdit(response.data.data[0].horario_fin_format)
                setInputVenueEdit(response.data.data[0].id_venue)
                setInputStatusEdit(response.data.data[0].status)
                setInputRestriccionEdit(response.data.data[0].restriccion_horario)
                setInputHorariosEspecificosEdit(response.data.data[0].horarios_especificos)
                setInputCapacidadEdit(response.data.data[0].capacidad)
            })

            instance.get('../api/get-horarios/'+item_id)
            .then(response => {
                setHorarios(response.data.data)
            })

            instance.get('../api/get-html/'+item_id)
            .then(response => {
                setHtmlCode(response.data.data)
            })

    }

    const handleShowAdd = async () => {
        setShowAdd(true);
    }

    const handleShowDelete = (item_id) => {
        setShowDelete(true);
        setDeleteId(item_id)
    }

    const handleShowDeleteHorario = (item_id) => {
        setShowDeleteHorario(true);
        setDeleteIdHorario(item_id)
    }

    const  handleDelete = () => {
        deleteEvento(deleteId)
    }

    const  handleDeleteHorario = () => {
        deleteHorario(deleteIdHorario)
    }
    
    
    const getData= async () => {
        
        setShowLoader(true);
        let ud = sessionStorage.getItem('userData');
        let userData = JSON.parse(ud);

        const instance = axios.create({
                baseURL: '',
                timeout: 10000,
                headers: {'content-type': 'application/json', 'Authorization': 'Bearer '+userData.access_token}
                });
        

        await instance.get('../api/get-venues')
        .then(response2 => {
            setSelectVenues(response2.data)
            setShowLoader(false);
        })

        if(id){
            await instance.get('../api/get-eventos/active')
            .then(response => {
                setItems(response.data)
                setShowLoader(false);
            })
        }
        else{
            await instance.get('../api/get-eventos')
            .then(response => {
                setItems(response.data)
                setShowLoader(false);
            })
        }

          

        //)
    }

    useEffect(()=>{
       getData();
    },[id]);

    const deleteEvento=(id)=>{
            
        let ud = sessionStorage.getItem('userData');
        let userData = JSON.parse(ud);

        const instance = axios.create({
                baseURL: '',
                timeout: 5000,
                headers: {'content-type': 'application/json', 'Authorization': 'Bearer '+userData.access_token}
                });
        
        trackPromise(
            instance.delete('../api/delete-evento/'+id)
            .then(response => {
                //console.log(response.status)
                if(response.status === 200){
                    setShowDelete(false);
                    setDeleteId("")
                    setShowAlertDelete(true)
                    getData()
                }
            })
        );
    }

    const deleteHorario=(id)=>{
            
        let ud = sessionStorage.getItem('userData');
        let userData = JSON.parse(ud);

        const instance = axios.create({
                baseURL: '',
                timeout: 5000,
                headers: {'content-type': 'application/json', 'Authorization': 'Bearer '+userData.access_token}
                });
        
        trackPromise(
            instance.delete('../api/delete-horario/'+id)
            .then(response => {
                //console.log(response.status)
                if(response.status === 200){

                    instance.get('../api/get-horarios/'+inputIdEdit)
                    .then(response => {
                        setHorarios(response.data.data)
                    });

                    alert("Eliminado con éxito")
                }
            })
        );
    }

    const handleSubmitEdit = async (event) => {

        event.preventDefault();
        setBtnSubmitEdit(true);


        if( inputNombreEdit && inputFechaEdit && inputHorarioEdit && inputHorarioFinEdit && inputVenueEdit && inputRestriccionEdit>=0 && inputStatusEdit>=0 && inputHorariosEspecificosEdit>=0){
          
            // ----------------------- nuevo endpoint con attach de photo

            let ud            = sessionStorage.getItem('userData');
            let userData      = JSON.parse(ud);

            const formData = new FormData();
            formData.append('_method', 'post');
            formData.append("nombre", inputNombreEdit)
            formData.append("fecha_evento", inputFechaEdit)
            formData.append("horario", inputHorarioEdit)
            formData.append("horario_fin", inputHorarioFinEdit)
            formData.append("id_venue", inputVenueEdit)
            formData.append("restriccion", inputRestriccionEdit)
            formData.append("horarios_especificos", inputHorariosEspecificosEdit)
            formData.append("capacidad", inputCapacidadEdit)
            formData.append("status", inputStatusEdit)
            formData.append("file", imageEdit.data)
            
            // console.log(imageEdit)

            fetch("../api/update-evento/"+inputIdEdit, {
                method: "POST",
                body: formData,
                //headers: {'Content-Type': 'multipart/form-data', 'Authorization': 'Bearer '+userData.access_token}
                headers: {'Authorization': 'Bearer '+userData.access_token}
              })
              .then(response => {
                if(response.status === 200){
                    setShow(false)
                    setTimeout(console.log("wait.."), 4000); 
                    getData()
                    setBtnSubmitEdit(false)
                    
                  }
              })
              .catch(function (error) {
                console.log(error)
                setBtnSubmitEdit(false)
              });

        //   var data_send = {
        //     "nombre": inputNombreEdit,
        //     "fecha_evento": inputFechaEdit,
        //     "horario": inputHorarioEdit,
        //     "id_venue": inputVenueEdit,
        //     "restriccion": inputRestriccionEdit,
        //     "horarios_especificos": inputHorariosEspecificosEdit,
        //     "capacidad": inputCapacidadEdit,
        //     "status": inputStatusEdit,
        //   }

        //   console.log(data_send);









    
        //   const instance = axios.create({
        //           baseURL: '',
        //           timeout: 5000,
        //           headers: {'content-type': 'application/json', 'Authorization': 'Bearer '+userData.access_token}
        //           });
            
            // instance.put('/api/update-evento/'+inputIdEdit, data_send)
            // .then(response => {
            //     //console.log(response)
            //     if(response.data.status === "200"){
            //         // setInputNombreEdit("");
            //         // setInputExistenciasEdit("");
            //         setShow(false)
            //         setShowAlert(true)
            //         getData()
            //     }
            // })
            // .catch(function (error) {
            //     if(error.response.status === "401"){
            //     console.log(error)
                
            //     }
            // });
    
    
        }
        else{
          //return error
          alert("Faltan datos"+inputNombreEdit +" "+ inputFechaEdit +" "+ inputHorarioEdit +" "+ inputVenueEdit +" "+ inputRestriccionEdit +" "+ inputStatusEdit +" "+ inputHorariosEspecificosEdit);
        }
        
    }

    const handleSubmit = async (event) =>{

        event.preventDefault();
        setStatusBtnAdd(true)
        if(inputNombre && inputFecha && inputHorario && inputVenue && image && inputStatus>=0 && inputRestriccion>=0 && inputHorariosEspecificos>=0){
            
              // ----------------------- nuevo endpoint con attach de photo

              let ud            = sessionStorage.getItem('userData');
              let userData      = JSON.parse(ud);

              const formData = new FormData();
              formData.append('_method', 'post');
              formData.append("nombre", inputNombre)
              formData.append("fecha_evento", inputFecha)
              formData.append("horario", inputHorario)
              formData.append("horario_fin", inputHorarioFin2)
              formData.append("id_venue", inputVenue)
              formData.append("status", inputStatus)
              formData.append("restriccion", inputRestriccion)
              if(inputRestriccion>0)
                formData.append("horarios_especificos", 0)
              else
                formData.append("horarios_especificos", inputHorariosEspecificos)
                
              formData.append("capacidad", inputCapacidad)
              formData.append("file", image.data)

              fetch("../api/add-evento", {
                method: "POST",
                body: formData,
                // headers: {'Content-Type': 'multipart/form-data', 'Authorization': 'Bearer '+userData.access_token}
                headers: {'Authorization': 'Bearer '+userData.access_token}
              })
              .then(response => {
                console.log(response.data)
                if(response.status === 200){
                    setInputNombre("");
                    setInputFecha("");
                    setInputHorario("");
                    setInputVenue("");
                    setInputStatus("");
                    setInputRestriccion("");
                    setInputHorariosEspecificos("");
                    setShowAdd(false)
                    setImage("")
                    setShowAlert(true)
                    setTimeout(
                        getData()
                        , 3000); 
                    setStatusBtnAdd(false)
                   
                  }
              })
              .catch(function (error) {
                console.log(error)
                setStatusBtnAdd(false)
              });

        }
        else{
            alert("Error #3435, [ Faltan datos ]"+inputNombre + inputFecha + inputHorario + inputVenue + inputStatus);
            setStatusBtnAdd(false)
        }
    }

    const handleSubmitHtmlCode = async (event) =>{

        event.preventDefault();
        // setStatusBtnAdd(true)
        if(htmlCode && inputIdEdit){
            console.log(inputIdEdit)
            console.log(htmlCode)
              // ----------------------- nuevo endpoint con attach de photo

            let ud            = sessionStorage.getItem('userData');
            let userData      = JSON.parse(ud); 
    
            const instance = axios.create({
                baseURL: '',
                timeout: 5000,
                headers: {'content-type': 'application/json', 'Authorization': 'Bearer '+userData.access_token}
                });

            var data_send = {
                "html_content": htmlCode
            }
                
            instance.post("../api/edit-html-code/"+inputIdEdit, data_send)
            .then(response => {
                if(response.status === 200)
                    alert("Guardado con éxito")
                else   
                    alert("Error, revise los datos")
            })
            .catch(function (error) {
                console.log(error)
                // setStatusBtnAdd(false)
            });

        }
        else{
            alert("Error #3435, [ Faltan datos ] "+inputIdEdit);
            // setStatusBtnAdd(false)
        }
    }

    const handleSubmitHorario = (event) =>{

        event.preventDefault();

        if(inputHorarioInicio && inputHorarioFin && inputCapacidadHorario){
            
            
            var data_send = {
                "horario_inicio": inputHorarioInicio,
                "horario_fin": inputHorarioFin,
                "capacidad": inputCapacidadHorario,
                "id_evento": inputIdEdit,
              }

        
              let ud = sessionStorage.getItem('userData');
              let userData = JSON.parse(ud);
        
              const instance = axios.create({
                      baseURL: '',
                      timeout: 5000,
                      headers: {'content-type': 'application/json', 'Authorization': 'Bearer '+userData.access_token}
                      });
                
              instance.post('../api/add-horario', data_send)
              .then(response => {
    
                  if(response.data.status === "200"){
                    setInputHorarioInicio("");
                    setInputHorarioFin("");
                    setInputCapacidadHorario("");

                    instance.get('../api/get-horarios/'+inputIdEdit)
                    .then(response => {
                        setHorarios(response.data.data)
                    });

                    alert("Se guardo exitosamente")
                  }
              })
              .catch(function (error) {
               
                    if(error.response.status === "401"){
                      console.log("se venció el token, please update it")
                      window.location.replace("./refresh-token");
                      
                    }
              });

        }
        else{
            alert("Error #3435, [ Faltan datos ]"+inputHorarioInicio + inputHorarioFin + inputCapacidadHorario);
        }
    }

    const TableHorarios = ()=> {
        return (
            <>
                <Table striped bordered hover responsive  className='mt-4'>
                    <thead>
                        <tr>
                            <th>Entrada</th>
                            <th>Salida</th>
                            <th>Capacidad</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                            {
                                horarios && horarios.length>0 && horarios.map((item)=> {         
                                return(
                                        <>
                                            <tr>
                                                <td>{item.hora_inicial}</td>
                                                <td>{item.hora_fin}</td>
                                                <td>{item.capacidad}</td>
                                                <td><TiDelete onClick={() => handleShowDeleteHorario(item.id)} /></td>
                                            </tr>  
                                        </>
                                    )
                                }) 
                            }
                    </tbody>
                </Table>
                
                <Row>
                    <Col className='mt-3'>
                            <hr></hr>
                    </Col>
                </Row>
                <Row>
                    <Col className='mt-1'>
                        <h4 className='titulo_soft'>Agregar nuevo horario</h4>
                    </Col>
                </Row>
                <Row className='mt-2'>
                    <Col>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label className='label_soft'>Horario inicio</Form.Label>
                            <Form.Select id="inp_horario_inicio" className='input_soft' aria-label="Default select example" value={inputHorarioInicio} onChange={(e) => setInputHorarioInicio(e.target.value)} >
                                <option>Seleccionar...</option>
                                <option value="00:00">00:00</option>
                                <option value="00:30">00:30</option>
                                <option value="01:00">01:00</option>
                                <option value="01:30">01:30</option>
                                <option value="02:00">02:00</option>
                                <option value="02:30">02:30</option>
                                <option value="03:00">03:00</option>
                                <option value="03:30">03:30</option>
                                <option value="04:00">04:00</option>
                                <option value="04:30">04:30</option>
                                <option value="05:00">05:00</option>
                                <option value="05:30">05:30</option>
                                <option value="06:00">06:00</option>
                                <option value="06:30">06:30</option>
                                <option value="07:00">07:00</option>
                                <option value="07:30">07:30</option>
                                <option value="08:00">08:00</option>
                                <option value="08:30">08:30</option>
                                <option value="09:00">09:00</option>
                                <option value="09:30">09:30</option>
                                <option value="10:00">10:00</option>
                                <option value="10:30">10:30</option>
                                <option value="11:00">11:00</option>
                                <option value="11:30">11:30</option>
                                <option value="12:00">12:00</option>
                                <option value="12:30">12:30</option>
                                <option value="13:00">13:00</option>
                                <option value="13:30">13:30</option>
                                <option value="14:00">14:00</option>
                                <option value="14:30">14:30</option>
                                <option value="15:00">15:00</option>
                                <option value="15:30">15:30</option>
                                <option value="16:00">16:00</option>
                                <option value="16:30">16:30</option>
                                <option value="17:00">17:00</option>
                                <option value="17:30">17:30</option>
                                <option value="18:00">18:00</option>
                                <option value="18:30">18:30</option>
                                <option value="19:00">19:00</option>
                                <option value="19:30">19:30</option>
                                <option value="20:00">20:00</option>
                                <option value="20:30">20:30</option>
                                <option value="21:00">21:00</option>
                                <option value="21:30">21:30</option>
                                <option value="22:00">22:00</option>
                                <option value="22:30">22:30</option>
                                <option value="23:00">23:00</option>
                                <option value="23:30">23:30</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label className='label_soft'>Horario fin</Form.Label>
                            <Form.Select id="inp_horario_fin" className='input_soft' aria-label="Seleccionar..." value={inputHorarioFin} onChange={(e) => setInputHorarioFin(e.target.value)}>
                            <option>Seleccionar...</option>
                                <option value="00:00">00:00</option>
                                <option value="00:30">00:30</option>
                                <option value="01:00">01:00</option>
                                <option value="01:30">01:30</option>
                                <option value="02:00">02:00</option>
                                <option value="02:30">02:30</option>
                                <option value="03:00">03:00</option>
                                <option value="03:30">03:30</option>
                                <option value="04:00">04:00</option>
                                <option value="04:30">04:30</option>
                                <option value="05:00">05:00</option>
                                <option value="05:30">05:30</option>
                                <option value="06:00">06:00</option>
                                <option value="06:30">06:30</option>
                                <option value="07:00">07:00</option>
                                <option value="07:30">07:30</option>
                                <option value="08:00">08:00</option>
                                <option value="08:30">08:30</option>
                                <option value="09:00">09:00</option>
                                <option value="09:30">09:30</option>
                                <option value="10:00">10:00</option>
                                <option value="10:30">10:30</option>
                                <option value="11:00">11:00</option>
                                <option value="11:30">11:30</option>
                                <option value="12:00">12:00</option>
                                <option value="12:30">12:30</option>
                                <option value="13:00">13:00</option>
                                <option value="13:30">13:30</option>
                                <option value="14:00">14:00</option>
                                <option value="14:30">14:30</option>
                                <option value="15:00">15:00</option>
                                <option value="15:30">15:30</option>
                                <option value="16:00">16:00</option>
                                <option value="16:30">16:30</option>
                                <option value="17:00">17:00</option>
                                <option value="17:30">17:30</option>
                                <option value="18:00">18:00</option>
                                <option value="18:30">18:30</option>
                                <option value="19:00">19:00</option>
                                <option value="19:30">19:30</option>
                                <option value="20:00">20:00</option>
                                <option value="20:30">20:30</option>
                                <option value="21:00">21:00</option>
                                <option value="21:30">21:30</option>
                                <option value="22:00">22:00</option>
                                <option value="22:30">22:30</option>
                                <option value="23:00">23:00</option>
                                <option value="23:30">23:30</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group className="mb-3" controlId="inp_capacidad_horario2">
                            <Form.Label className='label_soft'>Capacidad</Form.Label>
                            <Form.Control id="inp_capacidad_horario" type="text" className='input_soft' defaultValue={inputCapacidadHorario} onChange={(e) => setInputCapacidadHorario(e.target.value)}  placeholder="Asistentes" required />
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div className="d-grid gap-2">
                            <Button className='input_soft' onClick={(handleSubmitHorario)} variant="danger">Guardar</Button>
                        </div>
                    </Col>
                </Row>
            </>
        )
    }

    return (
        <>
            <Container>

                {showLoader ? <>       
                    <div className='loader-div'>
                            <Spinner animation="border" className='spinner_color' color={'#097969'} role="status">
                                <span className="visually-hidden">Loading...</span>
                            </Spinner><br />
                            <h3 className='loading_txt'>Loading ...</h3>
                        </div></> : ""
                }

                <Row className='mt-4 mb-3 d-flex align-items-center justify-content-between'>
                    <Col lg={9} xs={12} md={9} className='mb-3'>
                        <h1 className='semibold mb-1'>Eventos</h1>
                    </Col>
                    <Col lg={2} xs={12} md={3}>
                        <Button type="button" onClick={() => handleShowAdd()} className='btn-primary semibold w-100 py-2'><FontAwesomeIcon icon={faAdd} size='1x' className='me-2'/>Crear Evento</Button>
                    </Col>
                </Row>

                <Row className='mb-5 d-flex justify-content-end'>
                    <Col>
                        {
                            id ? (
                                <>
                                    <Button variant="success" className='disableed' disabled >Viendo activos</Button>
                                    &nbsp; 
                                    <a href="../eventos">
                                        <Button variant="dark" className='activeed' >Ver todos</Button>
                                    </a>
                                    
                                </>
                                
                            ):(
                                <>
                                    <Button variant="dark" className='disableed' disabled >Viendo todos</Button>
                                    &nbsp;
                                    <a href="eventos/active">
                                        <Button variant="success" className='activeed' >Ver activos</Button>
                                    </a> 
                                </>
                            )
                        }
                        
                        
                    </Col>
                </Row>

                <Alert className="mt-4" key="success" variant="success" show={showAlert} onClose={() => setShowAlert(false)} dismissible>
                    El evento se guardó exitosamente
                </Alert>

                <Alert className="mt-4" key="danger" variant="danger" show={showAlertDelete} onClose={() => setShowAlertDelete(false)} dismissible>
                    El evento se eliminó exitosamente
                </Alert>

                <Row className='justify-content-start'>
                {
                        items && items.length>0 && items.map((item)=> {
                            
                            {/* var txt_status          = ""
                            var txt_restriccion     = ""
                            var txt_horarios_esp    = "" */}
                            var imagen_final        = ""
                            var fecha_final         = ""

                            {/* if(item.status === 1)
                                txt_status = "Activo"
                            else
                                txt_status = "Inactivo"

                            if(item.restriccion_horario === 1)
                                txt_restriccion = "Activo"
                            else
                                txt_restriccion = "Inactivo"

                            if(item.horarios_especificos === 1)
                                txt_horarios_esp = "Entrada por horarios"
                            else
                                txt_horarios_esp = "Entrada general" */}

                            imagen_final = "https://storage.googleapis.com/bucket-qr-codes/"+item.imagen_url

                            var fecha_raw = item.fecha_evento_format;
                            var porc = fecha_raw.split('-');
                            var meses = ['', 'Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];
                            fecha_final = porc[2] + " " + meses[parseInt(porc[1], 10)] + " " + porc[0];

                            //console.log(item)
                            //var previa2 = item.fecha_evento_format;
                            var previa = new Date()
                            var previa2 = new Date(item.fecha_evento_format)
                    
                            return (
                                <Col lg={4} xs={12} md={5} className="position-relative d-flex justify-content-center mb-4">
                                    {
                                        (item.status !== 1 || previa > previa2 ) ? 
                                            (
                                                <>
                                                    <div className='etiqueta-inactivo'>Inactivo</div>
                                                </>
                                            ):
                                            (
                                                <>
                                                <div className='etiqueta-activo'>Activo</div> 
                                                </>
                                            )
                                        
                                    }
                                    
                                    <Card style={{ width: '20rem' }}>
                                        <div>
                                            <img alt={item.nombre} src={imagen_final} className="w-100 border-cards" />
                                        </div>
                                        <Card.Body>
                                            <Card.Title className='mb-0'>{item.nombre}</Card.Title>
                                                <p className='card-date'>{fecha_final}, {item.horario_format} horas</p>
                                            <Card.Text>
                                                <span className='card-copy semibold mb-0'>Venue</span><br />
                                                <span className='card-copy'>{item.nombre_venue}</span>
                                            </Card.Text>
                                            <Row className='d-flex justify-content-between'>
                                                <Col lg={6} xs={12} md={12}>
                                                    <Button type="button" onClick={() => handleShow(item.ide)} className='btn-primary semibold w-100 mt-3 py-2'><FontAwesomeIcon icon={faEdit} size='1x' className='me-2'/>Editar</Button>
                                                </Col>
                                                <Col lg={6} xs={12} md={12}>
                                                    <Button type="button"  onClick={() => handleShowDelete(item.ide)} className='btn-danger semibold w-100 mt-3 py-2'><FontAwesomeIcon icon={faTrash} size='1x' className='me-2'/>Eliminar</Button>
                                                </Col>
                                            </Row>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            )
                        }
                        )
                    }
                    
                </Row>

            </Container>

                <Modal show={showAdd} onHide={handleCloseAdd}>
                        <Modal.Header className='none-div' closeButton>
                        <Modal.Title>Agregar Evento</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>

                            <Container>
                                <Row>
                                    <Form.Group className="mb-3" controlId="formBasicEmail">
                                        <Form.Label htmlFor="input_nombre">Nombre del evento</Form.Label>
                                        <Form.Control 
                                        id="input_nombre"
                                        type="text" 
                                        placeholder="Nombre del evento"
                                        // defaultValue={}
                                        onKeyUp={(e) => setInputNombre(e.target.value)}
                                        required />
                                    </Form.Group>
                                </Row>

                                <Row>
                                    <Form.Group className="mb-3" controlId="formBasicEmail">
                                        <Form.Label htmlFor="input_nombre">Venue</Form.Label>
                                        <Form.Select aria-label="Seleccione..." onChange={(e) => setInputVenue(e.target.value)}>
                                            <option>Seleccione...</option>
                                            {
                                                selectVenues.map((item)=> 
                                                    (<option value={item.id}>{item.nombre_venue}</option>))
                                            }
                                        </Form.Select>
                                    </Form.Group>
                                </Row>
                                <Row>
                                    <Form.Group controlId="formFile" className="mb-3">
                                        <Form.Label>Foto del evento (640px x 320px)</Form.Label>
                                        <Form.Control type="file" onChange={handleFileChange}
                                        required />
                                    </Form.Group>
                                </Row>
                                
                                <Row>
                                    <Col>
                                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                            <Form.Label>Fecha</Form.Label>
                                            <Form.Control type="date" onChange={(e) => setInputFecha(e.target.value)} placeholder="fecha evento" />
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                            <Form.Label>Horario inicio</Form.Label>
                                            <Form.Control type="text" onKeyUp={(e) => setInputHorario(e.target.value)} placeholder="10:00" />
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                            <Form.Label>Horario fin</Form.Label>
                                            <Form.Control type="text" onKeyUp={(e) => setInputHorarioFin2(e.target.value)} placeholder="20:00" />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Form.Group className="mb-3" controlId="formBasicEmail">
                                            <Form.Label htmlFor="input_nombre">Restricción de horario</Form.Label>
                                            <Form.Select aria-label="Seleccione..." onChange={(e) => setInputRestriccion(e.target.value)}>
                                                <option>Seleccione...</option>
                                                <option value="1">Activo</option>
                                                <option value="0">Inactivo</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                
                                    {   inputRestriccion< 1 &&
                                        <Col>
                                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                                <Form.Label htmlFor="input_nombre">Horarios específicos</Form.Label>
                                                <Form.Select aria-label="Seleccione..." onChange={(e) => {  setInputHorariosEspecificos(e.target.value)  } }>
                                                    <option>Seleccione...</option>
                                                    <option value="0">Entrada general</option>
                                                    <option value="1">Entrada por horarios</option>
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                    }
                                    
                                </Row>

                            {
                                inputRestriccion === "1" || inputHorariosEspecificos == "0"  ? 
                                    (
                                        <Row>
                                            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1" >
                                                <Form.Label>Capacidad del evento</Form.Label>
                                                <Form.Control type="text" defaultValue={inputCapacidad} onKeyUp={(e) => setInputCapacidad(e.target.value)} placeholder="personas por evento" />
                                            </Form.Group>
                                        </Row>
                                    ) : (<></>)
                                }

                                <Row>
                                    <Form.Group className="mb-3" controlId="formBasicEmail">
                                        <Form.Label htmlFor="input_nombre">Status</Form.Label>
                                        <Form.Select aria-label="Seleccione..." onChange={(e) => setInputStatus(e.target.value)}>
                                            <option>Seleccione...</option>
                                            <option value="1">Activo</option>
                                            <option value="0">Inactivo</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Row>

                                <Row>
                                    <Col>
                                        <Button className='btn_buscar btn_right' disabled={statusBtnAdd} type="submit" onClick={(handleSubmit)}>
                                            Guardar
                                        </Button>
                                    </Col>
                                </Row>
                            </Container>
                        </Modal.Body>
                </Modal>

                <Modal show={show} size="lg" onHide={handleClose}>
                    <Modal.Header className='none-div' closeButton>
                    <Modal.Title>Editar Evento</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>

                        <Tabs defaultActiveKey="formulario" id="uncontrolled-tab-example" className="mb-3">

                            <Tab eventKey="formulario" className='mt-3' title="Información">

                                <Container>
                                    <Row>
                                        <Form.Group className="mb-3" controlId="formBasicEmail">
                                            <Form.Label htmlFor="input_nombre">Nombre del evento</Form.Label>
                                            <Form.Control 
                                            id="input_nombre"
                                            type="text" 
                                            placeholder="Nombre del evento"
                                            defaultValue={inputNombreEdit}
                                            onKeyUp={(e) => setInputNombreEdit(e.target.value)}
                                            required />
                                        </Form.Group>
                                    </Row>
                                    
                                    <Row>
                                        <Form.Group className="mb-3" controlId="formBasicEmail">
                                            <Form.Label htmlFor="input_nombre">Venue</Form.Label>
                                            <Form.Select aria-label="Seleccione..." value={inputVenueEdit} onChange={(e) => setInputVenueEdit(e.target.value)}>
                                                <option>Seleccione...</option>
                                                {
                                                    selectVenues.map((item)=> 
                                                        (<option value={item.id}>{item.nombre_venue}</option>))
                                                }
                                            </Form.Select>
                                        </Form.Group>
                                    </Row>

                                    <Row>
                                        <Form.Group controlId="formFile" className="mb-3">
                                            <Form.Label>Foto del evento</Form.Label>
                                            <Form.Control type="file" onChange={handleFileChangeEdit}
                                            required />
                                        </Form.Group>
                                    </Row>

                                    <Row>
                                        <Col>
                                            <Form.Group className="mb-3" controlId="exampleForm.Fecha">
                                                <Form.Label>Fecha</Form.Label>
                                                <Form.Control type="date" defaultValue={inputFechaEdit} onChange={(e) => setInputFechaEdit(e.target.value)} placeholder="fecha evento" />
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group className="mb-3" controlId="exampleForm.Horario">
                                                <Form.Label>Horario</Form.Label>
                                                <Form.Control type="text" defaultValue={inputHorarioEdit} onKeyUp={(e) => setInputHorarioEdit(e.target.value)} placeholder="20:00" />
                                            </Form.Group>
                                        </Col>   
                                        <Col>
                                            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                                <Form.Label>Horario fin</Form.Label>
                                                <Form.Control type="text" defaultValue={inputHorarioFinEdit} onKeyUp={(e) => setInputHorarioFinEdit(e.target.value)} placeholder="20:00" />
                                            </Form.Group>
                                        </Col>                         
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Form.Group className="mb-3" controlId="formBasicEmailRest">
                                                <Form.Label htmlFor="input_restriccion">Restriccion de horario</Form.Label>
                                                <Form.Select aria-label="Seleccione..." value={inputRestriccionEdit} onChange={(e) => setInputRestriccionEdit(e.target.value)}>
                                                    <option>Seleccione...</option>
                                                    <option value="1">Activo</option>
                                                    <option value="0">Inactivo</option>
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                        {   inputRestriccionEdit< 1 &&
                                                <Col>
                                                    <Form.Group className="mb-3" controlId="formBasicEmailHor">
                                                        <Form.Label htmlFor="input_tipo">Horarios específicos</Form.Label>
                                                        <Form.Select aria-label="Seleccione..." value={inputHorariosEspecificosEdit} onChange={(e) => setInputHorariosEspecificosEdit(e.target.value)}>
                                                            <option>Seleccione...</option>
                                                            <option value="1">Entrada por horarios</option>
                                                            <option value="0">Entrada general</option>
                                                        </Form.Select>
                                                    </Form.Group>
                                                </Col>
                                        }
                                    </Row>
                                    {
                                        inputRestriccionEdit === "1" || inputHorariosEspecificosEdit == "0"  ? 
                                        (
                                            <Row>
                                                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1" >
                                                    <Form.Label>Capacidad del evento</Form.Label>
                                                    <Form.Control type="text" defaultValue={inputCapacidadEdit} onKeyUp={(e) => setInputCapacidadEdit(e.target.value)} placeholder="personas por evento" />
                                                </Form.Group>
                                            </Row>
                                        ) : (<></>)
                                    }

                                    <Row>
                                        <Form.Group className="mb-3" controlId="formBasicEmail">
                                            <Form.Label htmlFor="input_nombre">Status</Form.Label>
                                            <Form.Select aria-label="Seleccione..." value={inputStatusEdit} onChange={(e) => setInputStatusEdit(e.target.value)}>
                                                <option>Seleccione...</option>
                                                <option value="1">Activo</option>
                                                <option value="0">Inactivo</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Row>     
                                    <Row>
                                        <Col>
                                            <Button className='btn_buscar btn_right' disabled={btnSubmitEdit} type="submit" onClick={(handleSubmitEdit)}>
                                                Editar
                                            </Button>
                                        </Col>     
                                    </Row>

                                </Container>

                            </Tab>
                            <Tab eventKey="horarios" title="Horarios espefificos">

                                    {
                                        inputHorariosEspecificosEdit>0 ? ( 
                                                <TableHorarios />
                                        ):(
                                            <>
                                                <Row>
                                                    <div className='text-center mt-4'> 
                                                        Esta funcionalidad está desactivada, por favor actívela desde la opción horarios específicos
                                                    </div>
                                                </Row>
                                            </>
                                        )
                                    }
                                
                            </Tab>
                            <Tab eventKey="plantilla" title="Diseño email">
                                <Container>
                                    <Row>
                                        <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                                            <Form.Label>Código Html</Form.Label>
                                            <Form.Control as="textarea" className='font-email' onKeyUp={(e) => setHtmlCode(e.target.value)} defaultValue={htmlCode} rows={20} />
                                        </Form.Group>
                                        <Button variant="success" type="submit" onClick={(handleSubmitHtmlCode)}>Guardar</Button>
                                    </Row>
                                </Container>
                            </Tab>
                        </Tabs>

                    </Modal.Body>
                </Modal>

                <Modal show={showDelete} onHide={handleCloseDelete}>
                    <Modal.Header closeButton>
                    <Modal.Title>Eliminar evento</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>¿Está seguro que desea eliminar este evento?</Modal.Body>
                    <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseDelete}>
                        Cancelar
                    </Button>
                    <Button variant="danger" onClick={() => handleDelete()} >
                        Confirmar
                    </Button>
                    </Modal.Footer>
                </Modal>

                <Modal show={showDeleteHorario} onHide={handleCloseDeleteHorario}>
                    <Modal.Header closeButton>
                    <Modal.Title>Eliminar horario</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>¿Está seguro que desea eliminar este horario?</Modal.Body>
                    <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseDeleteHorario}>
                        Cancelar
                    </Button>
                    <Button variant="danger" onClick={() => handleDeleteHorario()} >
                        Confirmar
                    </Button>
                    </Modal.Footer>
                </Modal>
            
        </>
    );
}

export default TableEventos;